// One source for the API address. REST calls (/admin/stripe/*,
// /admin/payments/*) used to fall back to production's api.acolide.com
// while GraphQL fell back to staging's api.bewta.com, so a build without
// REACT_APP_API_BASE (staging) sent those calls to production - without the
// superadmin's token, since the fetch wrapper in index.js only attaches it
// for the GraphQL host. REST now follows the GraphQL host unless
// REACT_APP_API_BASE says otherwise.
export const GRAPHQL_URL = process.env.REACT_APP_GRAPHQL_URL || "https://api.bewta.com/graphql";
export const API_BASE = process.env.REACT_APP_API_BASE || GRAPHQL_URL.replace(/\/graphql\/?$/, "");
